export default __webpack_public_path__ + "static/mini-helix-bq-2-e488d0c8a71bfaccb3a4cd3f02fbbf33.jpg";